import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { DeleteAlertModal } from '../../components/modal/DeleteAlertModal';
import { endpoints } from '../../api/endpoints';
import { Actions } from '../../components/table/TableActions';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { Box, Paper, Switch, Tooltip, Typography } from '@mui/material';
import { TablePagination } from '../../components/pagination/Pagination';
import { EllipsisText } from '../../components/styledComponent/typography/EllipsisText';
import { CustomAlertModal } from '../../components/modal/customAlertModal';
import { AppContext } from '../../contexts/AppContext';
import { useNavigate } from 'react-router-dom';

export default function LockerLocationListTable({ loading, setSelectedItem, setOpen, rows, count, skip, setSkip, take, setTake, setUpdateList, refetch, showApproved }: { loading: any, setOpen: any, setSelectedItem: any, rows: any, count: number, skip: number, setSkip: any, take: number, setTake: any, setUpdateList: React.Dispatch<any>, refetch: any, showApproved: string }) {

    const [openAlertModal, setOpenAlertModal] = React.useState(false);
    const [openApproveModal, setOpenApproveModal] = React.useState(false);
    const [selectedId, setSelectedID] = React.useState<any | null>();

    const { user } = React.useContext(AppContext)

    const onSuccess = () => {
        setOpenAlertModal(false)
        setOpenApproveModal(false)
        setSelectedID(null)
        refetch({ isMainTable: showApproved })
    }

    const onError = () => {
        setOpenAlertModal(false)
        setOpenApproveModal(false)
        setSelectedID(null)
    }

    const deleteAction = (row: any) => {
        setSelectedID(row.id);
        setOpenAlertModal(true)
    }

    const editAction = (row: any) => {
        setSelectedItem(row)
        setOpen(true)
    }

    const navigate = useNavigate()
    const viewAction = (row: any) => {
        navigate(`/locker-location/${row.id}?isMainTable=${showApproved}`)
    }

    return (<>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeadCell>S.N</TableHeadCell>
                            <TableHeadCell align="left">Branch Name</TableHeadCell>
                            <TableHeadCell align="left">Name</TableHeadCell>
                            <TableHeadCell align="left">Code</TableHeadCell>
                            <TableHeadCell align="left">Is Approved?</TableHeadCell>
                            <TableHeadCell align="left">Description</TableHeadCell>
                            <TableHeadCell align="center">Actions</TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!rows || loading ? <TableRowsLoader rowsNum={5} colNum={7} />
                            : rows.length <= 0 ? <TableRow><TableCell align="center" colSpan={7}>No data found</TableCell></TableRow>
                                : rows.map((row: any, index: number) => {
                                    return (
                                        <Tooltip sx={{ backgroundColor: '#121212' }} title={
                                            <Box>
                                                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                    <Box height="10px" width="10px" sx={{ backgroundColor: '#3150A1', padding: '6px' }}>
                                                    </Box>
                                                    <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created By: {row?.createdUser ?? "N/A"}</Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                    <Box height="10px" width="10px" sx={{ backgroundColor: '#f1c40f', padding: '6px' }}>
                                                    </Box>
                                                    <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated By: {row?.updatedUser ?? "N/A"}</Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                    <Box height="10px" width="10px" sx={{ backgroundColor: '#07bc0c', padding: '6px' }}>
                                                    </Box>
                                                    <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified By: {row?.verifiedUser ?? "N/A"}</Typography>
                                                </Box>
                                            </Box>
                                        } placement="bottom" arrow key={index}>
                                            <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                                                <TableCell align="left" style={{ fontSize: "12px" }}>{row.branchName}</TableCell>
                                                <TableCell align="left" style={{ fontSize: "12px" }}>{row.name}</TableCell>
                                                <TableCell align="left" style={{ fontSize: "12px" }}>{row.code}</TableCell>
                                                <TableCell align="left" style={{ fontSize: "12px" }}>
                                                    <Switch
                                                        checked={row.isApproved}
                                                        disabled={user?.role?.toLowerCase() === 'maker'}
                                                        onChange={() => {
                                                            if (row.isApproved !== true) {
                                                                setOpenApproveModal(true)
                                                                setSelectedID(row.id)
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell align="left" style={{ fontSize: "12px" }}>
                                                    <EllipsisText clamp={2} fontSize="12px">{row.description}</EllipsisText>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Actions onDelete={deleteAction} onEdit={editAction} onView={viewAction} row={row}
                                                        showEdit={user?.role?.toLowerCase() !== 'checker' && showApproved === 'true'}
                                                        showDelete={user?.role?.toLowerCase() !== 'checker' && showApproved === 'true'}
                                                        showView={true}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        </Tooltip>
                                    );
                                })}
                    </TableBody>
                </Table>
            </TableContainer>
            {rows?.length > 0 || !loading ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </Paper >
        < DeleteAlertModal
            onSuccess={onSuccess}
            onError={onError}
            endpoint={endpoints.lockerLocation.api}
            selectedId={selectedId}
            openAlertModal={openAlertModal}
            setOpenAlertModal={setOpenAlertModal}
        />
        <CustomAlertModal
            customEndpoint={true}
            onSuccess={onSuccess}
            onError={onError}
            endpoint={endpoints.lockerLocation.approved({ locationId: selectedId })}
            selectedId={selectedId}
            openAlertModal={openApproveModal}
            setOpenAlertModal={setOpenApproveModal}
            message={'Are you sure want to approve this locker location?'}
        />
    </>
    );
}
